import { useUser } from "src/settings/zustand/user"
import { Navigate, Outlet, Route, Routes } from "react-router"
import { labels } from "../../data/labels"
import { IToposStore, useToposStore } from "../../data/store"
import DiaryFeed from "../components/DiaryFeed"
import ToposLayoutContainer from "../components/ToposLayoutContainer"
import LandscapeContainer from "./LandscapeContainer"

const LandscapeForm = (props: any) : JSX.Element => {
    const user = useUser()
    const feedType: string = useToposStore((state:IToposStore) => state.feedType)
    const range: number = useToposStore((state:IToposStore) => state.range)
    const myFeedPaging = ` post_author: "${user.id}"`
    return <div className="w-100 h-100"> 
        <Routes> 
            <Route path="/*" element={<ToposLayoutContainer />} >
                <Route index element={ <Navigate replace to={ feedType || "feed" } /> } /> 
                <Route path="feed/*" element={ <LandscapeContainer onOpenLogin={props.onOpenLogin}/> } >
                    <Route index element={ <Navigate replace to={ labels[ range ] } /> } /> 
                    <Route path="year"  element={ <DiaryFeed paging="" title={"Diaries"} /> } />
                    <Route path="month" element={ <DiaryFeed paging="" title={"Diaries"} /> } />
                    <Route path="week"  element={ <DiaryFeed paging="" title={"Diaries"} /> } />
                    <Route path="day"   element={ <DiaryFeed paging="" title={"Diaries"} /> } />
                    <Route path="today" element={ <DiaryFeed paging="" title={"Diaries"} /> } />
                </Route>
                <Route path="my-feed/*" element={ <Outlet /> } >
                    <Route index element={ <Navigate replace to={ labels[ range ] } /> } /> 
                    <Route path="year"  element={ <DiaryFeed paging={ myFeedPaging } title={"My Freshness"} /> } />
                    <Route path="month" element={ <DiaryFeed paging={ myFeedPaging } title={"My Freshness"} /> } />
                    <Route path="week"  element={ <DiaryFeed paging={ myFeedPaging } title={"My Freshness"} /> } />
                    <Route path="day"   element={ <DiaryFeed paging={ myFeedPaging } title={"My Freshness"} /> } />
                    <Route path="today" element={ <DiaryFeed paging={ myFeedPaging } title={"My Freshness"} /> } />
                </Route>
            </Route>
        </Routes> 
    </div>
}
export default LandscapeForm